









































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { meta } from 'frontend/utils/decorators';
import { populateAdminMenu } from 'frontend/utils/admin';
import { LearningGroup, LearningPathInfo } from 'frontend/types';
import AdminMenu from 'frontend/components/AdminMenu.vue';
import CourseItem from 'frontend/views/learningPaths/CourseItem.vue';

@Component({
  components: {
    AdminMenu,
    CourseItem,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapState('learningPath', ['learningPath']),
    ...mapState('learningGroups', {
      learningGroups: (state: { items: LearningGroup[] }) => state.items,
    }),
  },
})
export default class LearningPath extends Vue {
  private learningPath!: LearningPathInfo;

  @meta
  private metaInfo() {
    return {
      title: this.learningPath.name,
    };
  }

  private get learningPathAdminMenu() {
    return populateAdminMenu(this.learningPath, 'learning path');
  }

  private groupAdminMenu(group: LearningGroup) {
    return populateAdminMenu(group, 'group');
  }
}
